import { render } from "./TaskModal.vue?vue&type=template&id=4269bb9a&scoped=true"
import script from "./TaskModal.vue?vue&type=script&lang=js"
export * from "./TaskModal.vue?vue&type=script&lang=js"

import "./TaskModal.vue?vue&type=style&index=0&id=4269bb9a&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4269bb9a"]])

export default __exports__